<template>
  <div class="wrapper">
    <div class="tab-options">
      <div class="filter-widget">
        <div class="search-widget">
          <div class="search-group">
            <img class="search" src="@/assets/icons/search.svg" />
            <input
              @keyup="searchContacts"
              placeholder="Search"
              type="Type in to Search"
            />
          </div>
        </div>
        <div class="filter-select-widget divider">
          <filter-select v-model="view_type" :content="display_filter"
            >Display</filter-select
          >
        </div>
        <div class="filter-select-widget divider">
          <img src="@/assets/admin-icon/filter.svg" />
          <filter-select v-model="tag_filter_data" :content="tags_filter"
            >Tags</filter-select
          >
        </div>
        <div class="filter-select-widget divider">
          <img src="@/assets/admin-icon/filter.svg" />
          <filter-select v-model="sort_filter_data" :content="sort_filter"
            >Filter</filter-select
          >
        </div>
      </div>

      <button class="btn-add" @click="addNew()">
        <span>Add Contact </span>
        <img src="@/assets/admin-icon/white-circle-plus.svg" />
      </button>
    </div>
    <div class="tab-body">
      <multipane class="custom-resizer" layout="vertical">
        <div class="contacts-table" v-if="view_type == 'list'">
          <table class="table-data">
            <thead class="table-header">
              <tr>
                <th>Name</th>
                <th>Account Name</th>
                <th class="phone-hide">Email</th>
                <th class="phone-hide">Phone</th>
                <th><div class="center">Action</div></th>
              </tr>
            </thead>
            <tbody class="table-body">
              <template v-for="(item, index) in contacts_data">
                <tr :key="index">
                  <td
                    @click="viewContact(item)"
                    :class="{ active: item.active }"
                  >
                    <div class="profile-content">
                      <div class="profile-alphabet">
                        <span>{{
                          $nameInitials(item.first_name + " " + item.last_name)
                            | validate
                        }}</span>
                      </div>
                      {{ (item.first_name + " " + item.last_name) | validate }}
                    </div>
                  </td>
                  <td
                    class="phone-hide"
                    @click="
                      $router.push({
                        name: 'account-view',
                        params: { type: 'overview', id: item.account.id },
                      })
                    "
                  >
                    {{ item.account.name | validate }}
                  </td>
                  <td class="phone-hide">
                    {{ item.email | validate }}
                  </td>
                  <td class="phone-hide">
                    {{ item.phone_alt | validate }}
                  </td>
                  <td>
                    <div class="menu">
                      <dropdownMenu>
                        <ul>
                          <li>
                            <a @click="updateContact(item)">Update</a>
                          </li>
                          <li>
                            <app-dialog
                              title="Delete Contact"
                              ask="Are you sure you want to delete this contact?"
                              yesText="Delete"
                              noText="Cancel"
                              @onComfirm="deleteContact(item.id)"
                            >
                              <a>Delete Contact</a>
                            </app-dialog>
                          </li>
                        </ul>
                      </dropdownMenu>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="contacts-items" v-else>
          <div
            class="contact-item"
            v-for="(item, index) in contacts_data"
            :key="index"
            @click="viewContact(item)"
            :class="{ active: item.active }"
          >
            <img src="@/assets/contact-avatar.svg" />
            <div class="contact-details-info">
              <h3>{{ (item.first_name + " " + item.last_name) | validate }}</h3>
              <h5>{{ item.title | validate }}</h5>
              <p class="email">{{ item.email | validate }}</p>
              <p class="phone">{{ item.phone_alt | validate }}</p>
            </div>
            <dropdown-menu class="menu">
              <ul>
                <li>
                  <a @click.prevent="updateContact(item)" href
                    >Update Contact</a
                  >
                </li>
                <li>
                  <app-dialog
                    title="Delete Contact"
                    ask="Are you sure you want to delete this contact?"
                    yesText="Delete"
                    noText="Cancel"
                    @onComfirm="deleteContact(item.id)"
                  >
                    <a>Delete Contact</a>
                  </app-dialog>
                </li>
              </ul>
            </dropdown-menu>
          </div>
        </div>
        <multipane-resizer></multipane-resizer>
        <div
          class="contact-details"
          :style="{ flexGrow: 1 }"
          v-if="contact_details"
        >
          <div class="contact-card">
            <img src="@/assets/contact-avatar.svg" />
            <h3>
              {{
                (contact_details.first_name + " " + contact_details.last_name)
                  | validate
              }}
            </h3>
            <h5>{{ contact_details.title | validate }}</h5>
            <p>{{ contact_details.email | validate }}</p>
            <p>{{ contact_details.phone_alt | validate }}</p>
            <div class="tags" v-if="contact_details.tags">
              <div
                class="tag"
                v-for="(item, index) in contact_details.tags"
                :key="index"
              >
                {{ item.name | validate }}
              </div>
            </div>
            <p class="comment">{{ contact_details.comment | validate }}</p>

            <dropdown-menu class="menu">
              <ul>
                <li>
                  <a @click.prevent="updateContact(contact_details)" href
                    >Update Contact</a
                  >
                </li>
                <li>
                  <app-dialog
                    title="Delete Contact"
                    ask="Are you sure you want to delete this contact?"
                    yesText="Delete"
                    noText="Cancel"
                    @onComfirm="deleteContact(contact_details.id)"
                  >
                    <a>Delete Contact</a>
                  </app-dialog>
                </li>
              </ul>
            </dropdown-menu>
          </div>

          <div
            class="widget-container"
            v-if="contact_details.tasks && contact_details.tasks.length > 0"
          >
            <div class="container-header">
              <h3>Tasks</h3>
              <button
                class="btn-view-all"
                @click="$router.push({ name: 'task' })"
              >
                View All
              </button>
            </div>
            <div class="widget-body">
              <div
                v-for="(task, i) in contact_details.tasks.slice(0, 5)"
                :key="i"
                class="card"
              >
                <div class="card-header">
                  <div class="title">
                    {{ task.name | validate }}
                  </div>
                  <div class="card-type">
                    <label :style="{ color: getColor(task.type) }">{{
                      task.type | validate
                    }}</label>
                    <div
                      :style="{ 'background-color': getColor(task.type) }"
                      class="type-box"
                    ></div>
                  </div>
                </div>
                <div class="compang-widget">
                  <span class="company-name" v-if="task.account">{{
                    task.account.name | validate
                  }}</span>
                </div>
                <div class="members">
                  <div
                    class="member"
                    v-for="(member, index) in task.assignees"
                    :key="index"
                  >
                    <assingProfileToolTip :member="member">
                      <img
                        v-if="member.profile_picture"
                        :src="
                          $fullUrl('images/profiles/' + member.profile_picture)
                        "
                        :class="{ override: index > 0 }"
                      />
                      <img
                        v-else
                        :class="{ override: index > 0 }"
                        src="@/assets/avatar.png"
                      />
                    </assingProfileToolTip>
                    <span v-if="task.assignees.length == 1" class="name">{{
                      (member.first_name + " " + member.last_name) | validate
                    }}</span>
                  </div>
                </div>
                <div class="due-date" v-if="task.due_date">
                  {{
                    moment(task.due_date).format("ddd, DD MMM YYYY") | validate
                  }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="widget-container"
            v-if="contact_details.leads && contact_details.leads.length > 0"
          >
            <div class="container-header">
              <h3>Leads</h3>
              <button
                class="btn-view-all"
                @click="$router.push({ name: 'leads' })"
              >
                View All
              </button>
            </div>
            <div class="widget-body">
              <div
                v-for="(lead, i) in contact_details.leads.slice(0, 5)"
                :key="i"
                class="lead-card"
              >
                <div class="card-header"></div>
                <div class="title-widget">
                  <span class="lead-name">{{ lead.name | validate }}</span>
                </div>
                <div class="compang-widget" v-if="lead.account">
                  <span class="company-name">
                    {{ lead.account.name | validate }}
                  </span>
                </div>

                <div class="members">
                  <div
                    class="member"
                    v-for="(member, index) in lead.assignees"
                    :key="index"
                  >
                    <assingProfileToolTip :member="member">
                      <img
                        v-if="member.profile_picture"
                        :src="
                          $fullUrl('images/profiles/' + member.profile_picture)
                        "
                        :class="{ override: index > 0 }"
                      />
                      <img
                        v-else
                        :class="{ override: index > 0 }"
                        src="@/assets/avatar.png"
                      />
                    </assingProfileToolTip>
                    <span v-if="lead.assignees.length == 1" class="name">{{
                      (member.first_name + " " + member.last_name) | validate
                    }}</span>
                  </div>
                </div>
                <div class="price">{{ lead.value | validate }} USD</div>
              </div>
            </div>
          </div>

          <div class="footer">
            <button class="btn-cancel" @click="contact_details = null">
              Close
            </button>
          </div>
        </div>
      </multipane>
    </div>

    <!-- Add - Update Modal -->
    <div class="overlay" v-if="show_form_add_update">
      <div class="form-widget-modal">
        <div class="moder-header">
          <h4 v-if="!contact_form.contact_id">Add a new Contact</h4>
          <h4 v-else>Update Contact</h4>
        </div>
        <div class="modal-body">
          <div class="input-group" v-if="!contact_form.contact_id">
            <label>Accounts*</label>
            <searchSelectInput
              v-model="accounts"
              url="/account/search"
              :miltiple="false"
              placeholder="Search Account"
            >
              <template v-slot:result="{ result }">
                <span class="search-account-item">{{
                  result.name | validate
                }}</span>
              </template>
              <template v-slot:selected="{ selected }">
                <span class="selected-search-account-item">{{
                  selected.name | validate
                }}</span>
              </template>
            </searchSelectInput>
          </div>
          <div class="twin-input">
            <div class="input-group">
              <label>First Name*</label>
              <input
                v-model="contact_form.first_name"
                type="text"
                class="input-form"
              />
            </div>
            <div class="input-group">
              <label>Last Name*</label>
              <input
                type="text"
                v-model="contact_form.last_name"
                class="input-form"
              />
            </div>
          </div>
          <div class="twin-input">
            <div class="input-group">
              <label>Phone</label>
              <input
                v-model="contact_form.phone_alt"
                type="text"
                class="input-form"
              />
            </div>
            <div class="input-group">
              <label>Email</label>
              <input
                v-model="contact_form.email"
                type="text"
                class="input-form"
              />
            </div>
          </div>
          <div class="twin-input">
            <div class="input-group">
              <label>Title</label>
              <input
                v-model="contact_form.title"
                type="text"
                class="input-form"
              />
            </div>
            <div class="input-group">
              <label>Tags</label>
              <TagsInput v-model="tags" />
            </div>
          </div>
          <div class="input-group">
            <label>Description</label>
            <textarea
              v-model="contact_form.comment"
              type="text"
              class="input-form"
            ></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <c-button
            :loading="adding_contact_loading"
            @click="submitAccountData()"
            class="btn-save"
            >Save</c-button
          >
          <button class="btn-cancel" @click="show_form_add_update = false">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
  components: {},
  data: () => ({
    view_type: "list",
    tag_filter_data: "",
    sort_filter_data: "",
    display_filter: [
      {
        value: "grid",
        name: "Grid",
      },
      {
        value: "list",
        name: "List",
      },
    ],
    tags_filter: [],
    sort_filter: [
      {
        value: "create_date",
        name: "Create Date",
      },
      {
        value: "name",
        name: "Name",
      },
    ],
    task_types: [
      {
        name: "Task",
        color: "#0884AF",
      },
      {
        name: "Follow up",
        color: "#1BA5A4",
      },
      {
        name: "Call",
        color: "#FFC273",
      },
      {
        name: "Mail",
        color: "#9FD076",
      },
      {
        name: "Meeting",
        color: "#ACAF5C",
      },
      {
        name: "Other",
        color: "#ED6400",
      },
    ],
    show_form_add_update: false,
    show_view_contant_modal: false,
    contact_form: {
      contact_id: null,
      account_id: null,
      first_name: "",
      last_name: "",
      description: "",
      comment: "",
      title: "",
      email: "",
      phone_alt: "",
      phone_work: "",
      tags: [],
      tags_added: [],
      tags_removed: [],
    },
    tags: {
      added: [],
      removed: [],
    },
    accounts: {
      added: [],
      removed: [],
    },
    adding_contact_loading: false,
    contacts_data: [],
    contact_details: null,
  }),
  mounted() {
    let vm = this;
    vm.getContactsData();
    vm.getContactsTags();
  },
  methods: {
    getColor(val) {
      let vm = this;
      let color = "";
      vm.task_types.forEach((item) => {
        if (item.name == val) {
          color = item.color;
        }
      });
      return color;
    },
    getContactsTags() {
      let vm = this;
      vm.$store
        .dispatch("CONTACTS_GET_TAGS")
        .then((response) => {
          response.data.forEach((item) => {
            vm.tags_filter.push({
              value: item.name,
              name: item.name,
            });
          });
        })
        .catch((error) => {});
    },
    filterBySort(val) {
      let vm = this;
      vm.$store
        .dispatch("CONTACTS_FILTER_BY_SORT", {
          option: val,
        })
        .then((response) => {
          vm.contacts_data = response.data;
        })
        .catch((error) => {});
    },
    filterByTag(val) {
      let vm = this;
      vm.$store
        .dispatch("CONTACTS_FILTER_BY_TAG", {
          option: val,
        })
        .then((response) => {
          vm.contacts_data = response.data;
        })
        .catch((error) => {});
    },
    searchContacts({ target }) {
      let vm = this;
      vm.$store
        .dispatch("CONTACTS_SEARCH", {
          query: target.value,
        })
        .then((response) => {
          vm.contacts_data = response.data;
        })
        .catch((error) => {});
    },
    deleteContact(id) {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_CONTACT_DELETE", { contact_id: id })
        .then((response) => {
          vm.getContactsData();
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    viewContact(item) {
      let vm = this;
      vm.$router.push({
        name: "accounts",
        params: { type: "contacts", id: item.id },
      });
      vm.contacts_data.forEach((item) => {
        item.active = false;
      });
      eventBus.$set(item, "active", true);
      vm.contact_details = item;
    },
    updateContact(item) {
      let vm = this;
      vm.contact_form.contact_id = item.id;
      vm.contact_form.account_id = item.account_id;
      vm.contact_form.first_name = item.first_name;
      vm.contact_form.last_name = item.last_name;
      vm.contact_form.description = item.description;
      vm.contact_form.comment = item.comment;
      vm.contact_form.title = item.title;
      vm.contact_form.email = item.email;
      vm.contact_form.phone_alt = item.phone_alt;
      vm.contact_form.phone_work = item.phone_work;
      vm.accounts = {
        added: [],
        removed: [],
      };
      vm.tags = {
        added: [],
        removed: [],
      };
      item.tags.forEach((item) => {
        eventBus.$set(item, "on_update", true);
        vm.tags.added.push(item);
      });
      vm.show_form_add_update = true;
    },
    getContactsData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("ACCOUNT_CONTACT_GET_DATA")
        .then((response) => {
          vm.contacts_data = response.data;
          if (!vm.$route.params.id) {
            if (window.innerWidth > 500) {
              if (vm.contacts_data.length > 0) {
                vm.viewContact(vm.contacts_data[0]);
              }
            }
          } else {
            vm.contacts_data.forEach((item) => {
              if (item.id == vm.$route.params.id) {
                vm.viewContact(item);
              }
            });
          }
          vm.$store.dispatch("LOADER_CLOSE");
        })
        .catch((error) => {
          console.error({ error });
          vm.$store.dispatch("LOADER_CLOSE");
        });
    },
    submitAccountData() {
      let vm = this;
      const rules = {
        first_name: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "First name can not be empty";
          },
        },
        last_name: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Last name can not be empty";
          },
        },
        title: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Title can not be empty";
          },
        },
        phone_alt: {
          run: (value) => {
            if (value.length == 0) {
              return "Phone number can not be empty";
            } else {
              if (/^\d+$/.test(value)) {
                return false;
              } else {
                return "We don't accept any character on phone number, use only number";
              }
            }
          },
        },

        email: {
          run: (value) => {
            if (value.length == 0) {
              return "Email can not be empty";
            } else {
              const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              if (re.test(String(value).toLowerCase())) {
                return false;
              }
            }
            return "Email is invalid";
          },
        },
      };
      if (vm.$isFieldsValidated(vm.contact_form, rules)) {
        vm.adding_contact_loading = true;
        vm.contact_form.tags = vm.tags.added.map((item) => {
          return item;
        });
        if (!vm.contact_form.contact_id) {
          vm.contact_form.account_id = vm.accounts.added[0].id;
          vm.$store
            .dispatch("ACCOUNT_CONTACT_ADD_NEW", vm.contact_form)
            .then((response) => {
              vm.adding_contact_loading = false;
              vm.show_form_add_update = false;
              vm.getContactsData();
            })
            .catch((error) => {
              console.error({ error });
              vm.adding_contact_loading = false;
            });
        } else {
          // For tags
          vm.contact_form.tags_added = vm.tags.added
            .filter((item) => !item.on_update)
            .map((item) => {
              return item;
            });
          vm.contact_form.tags_removed = vm.tags.removed.map((item) => {
            return item;
          });
          vm.$store
            .dispatch("ACCOUNT_CONTACT_UPDATE", vm.contact_form)
            .then((response) => {
              vm.adding_contact_loading = false;
              vm.show_form_add_update = false;
              vm.getContactsData();
            })
            .catch((error) => {
              console.error({ error });
              vm.adding_contact_loading = false;
            });
        }
      }
    },
    addNew() {
      let vm = this;
      vm.show_form_add_update = true;
      vm.accounts = {
        added: [],
        removed: [],
      };
      vm.tags = {
        added: [],
        removed: [],
      };
      vm.contact_form = {
        contact_id: null,
        account_id: vm.$route.params.id,
        first_name: "",
        description: "",
        comment: "",
        title: "",
        email: "",
        phone_alt: "",
        phone_work: "",
        tags: [],
        tags_added: [],
        tags_removed: [],
      };
    },
  },
  watch: {
    tag_filter_data(val) {
      let vm = this;
      vm.filterByTag(val);
    },
    sort_filter_data(val) {
      let vm = this;
      vm.filterBySort(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  .tab-options {
    @media (min-width: 300px) and (max-width: 630px) {
      left: unset;
    }
    .filter-widget {
      .search-widget {
        @media (min-width: 300px) and (max-width: 630px) {
          display: none;
        }
      }
    }
  }
  .phone-hide {
    @media (min-width: 300px) and (max-width: 630px) {
      display: none;
    }
  }
  .tab-body {
    height: calc(100% - 47px);
    width: 100%;
    overflow-y: unset;
    height: 100%;
    position: relative;
    padding: 0px;
    padding-left: 10px;
    padding-top: 10px;
    @media (min-width: 300px) and (max-width: 630px) {
      grid-template-columns: 100%;
    }
    .custom-resizer {
      height: 100%;
    }
    .active {
      border-left: 2px solid #ccc;
    }
    .contacts-table {
      background: #fff;
      border-radius: 5px;
      height: 100%;
      overflow-y: auto;
      min-width: calc(100% - 400px);
      width: 100%;
      padding: 10px 16px;
      .table-data {
        border-collapse: collapse;
        border-spacing: 0;
        tr {
          &:hover {
            background: rgb(248, 248, 248);
            cursor: pointer;
          }
          th {
            border-bottom: none;
            padding: 23px 0px !important;
            .center {
              width: 100%;
              display: flex;
              justify-content: center;
            }
          }
          td {
            .menu {
              width: 100%;
              display: flex;
              justify-content: center;
            }
            &:first-child {
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
            }
            &:last-child {
              border-top-right-radius: 5px;
              border-bottom-right-radius: 5px;
            }
            text-align: left;
            border-bottom: none;
            padding: 8px 15px;
            font-size: 13px;
            color: rgb(28, 28, 28);
            background: #efefef;
            border-bottom: 5px solid #fff;
          }
        }
      }
    }
    .contacts-items {
      display: grid;
      grid-template-columns: 32.3333% 32.3333% 32.3333%;
      grid-gap: 10px;
      align-items: flex-start;
      background: #fff;
      border-radius: 5px;
      height: 100%;
      overflow-y: auto;
      min-width: calc(100% - 400px);
      width: 100%;
      .contact-item {
        position: relative;
        background: #eeeeee;
        border-radius: 6px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 15px;
        min-height: 200px;
        cursor: pointer;
        &.active {
          background: #f8f8f8;
        }
        img {
          width: 80px;
          margin-bottom: 7px;
        }
        .contact-details-info {
          display: flex;
          flex-direction: column;
          align-items: center;
          h3 {
            margin: 0px;
            font-size: 18px;
            margin-bottom: 4px;
          }
          h5 {
            margin: 0px;
            font-size: 15px;
            color: #646262;
            margin-bottom: 10px;
          }
          p {
            margin: 0px;
            font-size: 13px;
            color: #646262;
          }
        }
        .menu {
          position: absolute;
          top: 8px;
          right: 10px;
        }
      }
    }
    .contact-details {
      padding-right: 10px;
      height: 100%;
      overflow-y: auto;
      padding-bottom: 100px;
      width: 300px;
      min-width: 300px;
      max-width: 400px;
      @media (min-width: 300px) and (max-width: 630px) {
        position: fixed;
        top: 0px;
        left: 0px;
        bottom: 0px;
        right: 0px;
        z-index: 999999;
        background: #fff;
      }
      .contact-card {
        position: relative;
        background: #fff;
        border-radius: 6px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 15px 25px;
        border: 1px solid #ddd;
        margin-bottom: 10px;
        @media (min-width: 300px) and (max-width: 630px) {
          border: none;
        }
        img {
          width: 80px;
          margin-bottom: 19px;
        }
        h3 {
          margin: 0px;
          font-size: 25px;
          margin-bottom: 4px;
        }
        h5 {
          margin: 0px;
          font-size: 14px;
          color: #646262;
          margin-bottom: 10px;
        }
        p {
          margin: 0px;
          font-size: 15px;
          margin-bottom: 10px;
          color: #646262;
        }
        p.comment {
          font-size: 14px;
          text-align: justify;
        }
        .menu {
          position: absolute;
          top: 20px;
          right: 10px;
        }
        .tags {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          margin-bottom: 10px;
          width: 100%;
          .tag {
            padding: 8px 10px;
            background: rgb(150, 150, 150);
            color: #fff;
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            margin-right: 8px;
            font-size: 11px;
            border-radius: 5px;
            .remove-btn {
              font-size: 14px;
              color: #fff;
            }
          }
        }
      }
      .widget-container {
        background: #ffffff;
        padding: 10px 10px;
        margin-bottom: 20px;
        border-radius: 5px;
        .container-header {
          display: flex;
          justify-content: space-between;
          padding: 15px 0px;
          h3 {
            font-size: 17px;
            margin: 0px;
          }
          .btn-view-all {
            color: #0884af;
          }
        }
        .widget-body {
          .card {
            width: 100%;
            background: #f5f5f5;
            position: relative;
            padding: 8px 8px;
            border-radius: 5px;
            margin-bottom: 5px;
            .card-header {
              display: flex;
              justify-content: space-between;
              margin-bottom: 5px;
              width: 100%;
              .title {
                font-size: 14px;
                font-family: "AvenirRoman";
                font-weight: 800;
                color: #000;
                overflow: hidden;
                text-decoration: none;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 99%;
              }

              .card-type {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                label {
                  font-size: 10px;
                  white-space: nowrap;
                  text-align: right;
                }
                .type-box {
                  height: 15px;
                  width: 15px;
                  border-radius: 2px;
                  margin-left: 5px;
                }
              }
            }
            .compang-widget {
              display: flex;
              flex-direction: column;
              padding-right: 20px;
              .company-name {
                color: #707070;
                font-size: 12px;
                margin-bottom: 5px;
              }
              .company-contact {
                display: flex;
                align-items: center;
                margin-bottom: 5px;
                span {
                  font-size: 12px;
                  white-space: nowrap;
                }
                .other-contact {
                  color: #ccc;
                  font-size: 12px;
                  white-space: nowrap;
                }
              }
            }
            .members {
              display: flex;
              .member {
                display: flex;
                align-items: center;
                img {
                  width: 20px;
                  height: 20px;
                  object-fit: cover;
                  margin-right: 4px;
                  border-radius: 50%;
                  border: 2px solid #fff;
                  &.override {
                    margin-left: -10px;
                  }
                }
                .name {
                  background: #06a1a11f;
                  padding: 2px 5px;
                  border-radius: 15px;
                  font-size: 11px;
                  color: #04a5a5;
                  display: block;
                }
              }
            }
            .due-date {
              position: absolute;
              bottom: 18px;
              right: 15px;
              font-size: 10px;
              display: none;
            }

            &.hold {
              border: solid#04a5a5 1px;
              border-radius: 5px;
            }
            &.invisible {
              opacity: 0.5;
            }
          }
          .lead-card {
            width: 100%;
            background: #f5f5f5;
            position: relative;
            padding: 15px 15px;
            cursor: pointer;
            border-radius: 5px;
            margin-bottom: 5px;
            &:hover {
              .card-header {
                .card-checkbox {
                  display: block;
                }
              }
            }
            .card-header {
              display: flex;
              justify-content: flex-end;
              position: absolute;
              right: 2px;
              top: 8px;
              .card-checkbox:checked {
                display: block;
              }
              .card-checkbox {
                display: none;
              }
            }
            .title-widget {
              margin-bottom: 5px;
              .lead-name {
                font-size: 14px;
                font-family: "AvenirRoman";
                font-weight: 800;
                color: #000;
                overflow: hidden;
                text-decoration: none;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 115px;
              }
            }
            .compang-widget {
              display: flex;
              justify-content: space-between;
              padding-right: 20px;
              .company-name {
                color: #0884af;
                font-size: 12px;
              }

              .company-contact {
                display: flex;
                align-items: center;
                margin-bottom: 5px;
                span {
                  font-size: 12px;
                  white-space: nowrap;
                }
                .other-contact {
                  color: #ccc;
                  font-size: 12px;
                  white-space: nowrap;
                }
              }
            }

            .members {
              margin-top: 5px;
              display: flex;
              .member {
                display: flex;
                align-items: center;
                img {
                  width: 20px;
                  height: 20px;
                  object-fit: cover;
                  margin-right: 4px;
                  border-radius: 50%;
                  border: 2px solid #fff;
                  &.override {
                    margin-left: -10px;
                  }
                }
                .name {
                  background: #06a1a11f;
                  padding: 2px 5px;
                  border-radius: 15px;
                  font-size: 11px;
                  color: #04a5a5;
                  display: block;
                }
              }
            }
            .price {
              color: rgb(134, 134, 134);
              position: absolute;
              bottom: 18px;
              right: 15px;
              font-size: 10px;
            }
            .attachment {
              width: 100%;
              padding: 0px 10px;
              img {
                width: 100%;
                height: 70px;
                object-fit: cover;
                border-radius: 20px;
              }
            }
          }
        }
      }
      .footer {
        display: none;
        justify-content: center;
        padding: 30px;
        @media (min-width: 300px) and (max-width: 630px) {
          display: flex;
        }
        .btn-cancel {
          background: #24a5a5;
          height: 50px;
          width: 125px;
          color: #fff;
          outline: none;
          border: none;
          border-radius: 5px;
          margin-right: 15px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
  .form-widget-modal {
    width: 500px;
  }
}
.search-account-item {
  padding: 10px 15px;
  display: block;
  cursor: pointer;
  &:hover {
    background: rgb(250, 250, 250);
  }
}
.selected-search-account-item {
  padding: 5px 12px;
  display: block;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;
  &:hover {
    background: rgb(250, 250, 250);
  }
}
</style>
